<div class="routing-rule-settings routing-rule-source">
  <div class="source-data-container">
    <ac-input-container label="Prefixes / Prefix Groups">
      <ac-select class="single-row"
                 [(acModel)]="source.rrAttrs.prefix"
                 (acModelChange)="updateLogicalConjunctionNotice();"
                 [multiple]="true"
                 [addCustomTags]="true"
                 [items]="prefixGroups"
                 bindLabel="name"
                 [bindValue]="null"
                 [combinedMode]="true"
                 [allowClear]="true">
      </ac-select>
    </ac-input-container>
    <ac-input-container label="Hosts">
      <ac-select class="single-row"
                 [(acModel)]="source.rrAttrs.host"
                 (acModelChange)="updateLogicalConjunctionNotice()"
                 [multiple]="true"
                 [searchable]="false"
                 [addCustomTags]="true"
                 [bindLabel]="null"
                 [bindValue]="null"
                 [allowClear]="true">
      </ac-select>
    </ac-input-container>
    <ac-input-container label="User Groups">
      <ac-select class="single-row"
                 [(acModel)]="source.userGroups"
                 (acModelChange)="updateLogicalConjunctionNotice()"
                 [multiple]="true"
                 [items]="userGroups"
                 [bindLabel]="'name'"
                 [bindValue]="'id'"
                 [allowClear]="true">
      </ac-select>
    </ac-input-container>
    <ac-input-container label="Customers">
      <ac-select class="single-row"
                 [(acModel)]="source.sourceCustomers"
                 (acModelChange)="updateLogicalConjunctionNotice()"
                 alternativeName="source.sourceCustomers"
                 [multiple]="true"
                 [ngDisabled]="source.allCustomers"
                 [items]="customers"
                 [bindLabel]="'name'"
                 [bindValue]="'id'"
                 [allowClear]="true">
      </ac-select>
    </ac-input-container>
    <mat-checkbox name="enableDate" color="primary" (change)="updateLogicalConjunctionNotice()"
                  [(ngModel)]="source.allCustomers">Use All Customers</mat-checkbox>

    <ac-input-container label="Resource Groups">
      <ac-select class="single-row"
                 [(acModel)]="source.resourceGroups"
                 (acModelChange)="updateLogicalConjunctionNotice()"
                 [multiple]="true"
                 [items]="resourceGroups"
                 [bindLabel]="'name'"
                 [bindValue]="'id'"
                 [groupBy]="'displayType'"
                 [allowClear]="true">
      </ac-select>
    </ac-input-container>

    <ac-input-container class="source-nodes-and-pcons" label="Nodes">
      <ac-select class="single-row"
                 [(acModel)]="source.nodes"
                 (acModelChange)="updateLogicalConjunctionNotice(); initializeMap()"
                 [multiple]="true"
                 [items]="nodes"
                 [groupBy]="'elementType'"
                 [bindLabel]="'name'"
                 [bindValue]="'id'"
                 [allowClear]="true">
      </ac-select>
    </ac-input-container>

    <ac-input-container class="source-nodes-and-pcons" label="Peer Connections">
      <ac-select class="single-row"
                 [(acModel)]="source.pCons"
                 (acModelChange)=" updateLogicalConjunctionNotice(); initializeMap()"
                 alternativeName="source.pCons"
                 [multiple]="true"
                 [items]="pCons"
                 [groupBy]="'elementType'"
                 [bindLabel]="'name'"
                 [bindValue]="'id'"
                 [allowClear]="true">
      </ac-select>
    </ac-input-container>

    <ac-input-container class="source-nodes-and-pcons" label="Reroute Peer Connections (for Refer and 3XX)">
      <ac-select class="single-row"
                 [(acModel)]="source.reroutePcons"
                 (acModelChange)=" updateLogicalConjunctionNotice(); initializeMap()"
                 alternativeName="source.reroutePcons"
                 [multiple]="true"
                 [items]="pCons"
                 [groupBy]="'elementType'"
                 [bindLabel]="'name'"
                 [bindValue]="'id'"
                 [allowClear]="true">
      </ac-select>
    </ac-input-container>


    <div class="logical-conjunction-notice" [innerHTML]="logicalConjunctionNotice"></div>
  </div>

  <div class="map-container">
    <choose-topology-item-container [diagramId]="'routing-rule-source'"
                                     [options]="mapOptions"
                                    (onClick)="onMapClick($event)">
    </choose-topology-item-container>
  </div>
</div>
